/* eslint-disable global-require */
import { adminRoutes } from './adminRoutes'; // Site Admin Routes
import { userRoutes } from './userRoutes';

let children = [];
children = children.concat(adminRoutes, userRoutes); // Merging different module routes

children.push({
  path: '(.*)',
  load: () => new Promise((resolve, reject) => {
    resolve(require('./notFound'));
    reject(error);
  }),
});


const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children,

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Untitled Page'}`;
    route.description = route.description || '';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;
